import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import Spinner from './Spinner'

interface LoadingOverlayProps {
  isVisible: boolean
  message?: string
  fullScreen?: boolean
  blur?: boolean
  className?: string
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  isVisible,
  message = 'Loading...',
  fullScreen = false,
  blur = true,
  className = ''
}) => {
  const overlayClasses = fullScreen
    ? 'fixed inset-0 z-50'
    : 'absolute inset-0 z-10'

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className={`${overlayClasses} flex items-center justify-center bg-white bg-opacity-80 ${
            blur ? 'backdrop-blur-sm' : ''
          } ${className}`}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            className="flex flex-col items-center space-y-4 p-6 bg-white rounded-lg shadow-lg"
          >
            <Spinner size="lg" />
            {message && (
              <p className="text-gray-700 text-sm font-medium">{message}</p>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default LoadingOverlay